import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const Header = ({ title, description }) => {
  const { t } = useTranslation();

  return (
    <header data-bem="Header--user" className="header">
      <span data-bem="Header__text" className="header-text">
        <h1>{t('composite.notFoundPage.header')}</h1>
        {title}
        <span data-bem="Header__sub" className="header-sub">
          {description}
        </span>
      </span>
    </header>
  );
};

export default Header;
